/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { personIndexDataLastActivitySchema } from './PersonIndexDataLastActivitySchema'

export const personIndexDataSchema = z.object({
	q: z.string().nullable().optional(),
	skillIds: z.array(z.string()).nullable().optional(),
	lastActivity: personIndexDataLastActivitySchema.nullable().optional(),
	page: z.number().optional().default(1),
	perPage: z.number().optional().default(25),
})

export type PersonIndexDataSchema = z.infer<typeof personIndexDataSchema>
